const { zipCodeRegexNumeric, onlyNumeric } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumeric(zipCode);
  if (zip.length <= 3) {
    return zip;
  }
  return `${zip.slice(0, 3)}-${zip.slice(3, 7)}`;
};

exports.countryDefinition = {
  country: 'Japan',
  code: 'JP',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City' },
    stateCode: { label: 'Prefecture' },
    zipCode: { label: 'Postal Code', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode'],
    ['zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(7)),
      error: 'Must be 7 characters, 123-4567'
    }
  ]
};
